import { getGsap, getScrollTrigger } from "../global/GsapGlobals";
import { DUR, EASE, motionOK } from "../global/MotionTokens";

const ROOT_SELECTOR = "[data-theh-solution]";
const CARD_SELECTOR = "[data-solution-step]";

export class ThehSolutionProgressController {
    static init(): void {
        const sections = Array.from(
            document.querySelectorAll<HTMLElement>(ROOT_SELECTOR),
        );
        if (!sections.length) return;

        sections.forEach((section) => {
            if (section.dataset.thehSolutionBound === "1") return;
            section.dataset.thehSolutionBound = "1";

            const cards = Array.from(
                section.querySelectorAll<HTMLElement>(CARD_SELECTOR),
            );
            if (!cards.length) return;

            const current = section.querySelector<HTMLElement>("[data-solution-current]");
            const currentTitle = section.querySelector<HTMLElement>("[data-solution-current-title]");
            const progress = section.querySelector<HTMLElement>("[data-solution-progress]");
            const gsap = getGsap();
            const ScrollTrigger = getScrollTrigger();
            let activeIndex = -1;

            const setActive = (nextIndex: number): void => {
                const index = Math.max(0, Math.min(nextIndex, cards.length - 1));
                if (index === activeIndex) return;
                activeIndex = index;

                cards.forEach((card, cardIndex) => {
                    card.classList.toggle("is-active", cardIndex === index);
                });

                const activeCard = cards[index];
                const step = activeCard.dataset.solutionStep ?? String(index + 1);
                if (current) current.textContent = step.padStart(2, "0");
                if (currentTitle) {
                    currentTitle.textContent = activeCard.dataset.solutionTitle ?? "";
                }
                if (progress) {
                    gsap.to(progress, {
                        scaleX: (index + 1) / cards.length,
                        duration: motionOK() ? DUR.base : 0,
                        ease: EASE.outQuart,
                        overwrite: true,
                    });
                }
            };

            setActive(0);

            const media = gsap.matchMedia();
            media.add("(min-width: 1025px)", () => {
                section.classList.add("is-solution-tracking");

                const triggers = cards.map((card, index) =>
                    ScrollTrigger.create({
                        trigger: card,
                        start: "top 52%",
                        end: "bottom 52%",
                        invalidateOnRefresh: true,
                        onEnter: () => setActive(index),
                        onEnterBack: () => setActive(index),
                        onLeaveBack: () => setActive(index - 1),
                    }),
                );

                return () => {
                    triggers.forEach((trigger) => trigger.kill());
                    section.classList.remove("is-solution-tracking");
                    cards.forEach((card) => card.classList.remove("is-active"));
                    activeIndex = -1;
                    setActive(0);
                };
            });
        });
    }
}
